import React from "react"
import videoImage from "../../images/new-landing/video.png"
import ReactGA from "react-ga";

export default function Why({toggleVideoModal}) {
  const gotoPricing = () => {
    try {
      document.querySelector('.new-pricing__hero').scrollIntoView({
        behavior: 'smooth',
        top: 0,
        left: 0,
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
    ReactGA.event({
      category: `Einvoicing Aus_Start your free 30 day trial_ Green button`,
      action: `Einvoicing Aus_Start your free 30 day trial_ Green button clicked`
    });
  }

  return (
      <div className="why">
        <div className="container flex flex-col md:flex-row justify-around items-center">
          <div className="left">
            <div className="fvideo cursor-pointer mx-auto  w-11/12 xl:w-full" onClick={toggleVideoModal}>
              <div className="fvideo__play"/>
              <img src={videoImage} alt="video"/>
            </div>
          </div>
          <div className="text-center mt-0 sm:mt-8 md:mt-0 sm:text-left sm:ml-16 xl:ml-0">
            <div className="text-accent sm:text-16 text-14 mt-6 sm:mt-0 font-bold">
              Introducing E-invoicing with LUCA Plus
            </div>
            <div className="text-xl sm:text-4xl mt-3 sm:mt-0 text-brand font-bold">
              Why sign up to LUCA Plus?
            </div>
            <div
                className="text-neutral-3
          font-sans leading-6 desc3 mt-2 w-10/12 sm:w-auto mx-auto"
            >
              It’s simple!<br /><br />

              LUCA Plus is your all-in-one platform to improve your business cash flow and back-office efficiency.<br /><br />

              This means saving up to 40 hours a month on back-office work. You get paid faster with accurate
              invoice delivery using our e-invoicing feature.
            </div>

            <div className="sm:mt-8 btn-trial">
              <a
                  onClick={gotoPricing}
                  className="bg-mind flex text-white rounded text-base focus:outline-none cursor-pointer hover:bg-mint2"
              >
                Start your Free 30 day Trial
              </a>
            </div>
          </div>
        </div>
      </div>
  )
}
